// Page index
export const DEFAULT_PAGE_INDEX = 0;
export const FIRST_PAGE_INDEX = 0;
// Page size
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZES = [DEFAULT_PAGE_SIZE, 100, 200, 300];

export const DEFAULT_LAST_ROW_SELECTED = { id: '', index: 0 };

// Sort number
export const DEFAULT_SORT_NUMBER_BY = { id: 'number', desc: true };
